import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { verifyPasswordResetCode, confirmPasswordReset } from 'firebase/auth';
import { auth } from '../firebase';

export const PasswordResetConfirmPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('idle'); // idle | verifying | success | error

  const params = new URLSearchParams(location.search);
  const oobCode = params.get('oobCode');

  useEffect(() => {
    const verify = async () => {
      if (!oobCode) {
        setStatus('error');
        setMessage('Invalid reset link.');
        return;
      }
      setStatus('verifying');
      setMessage('');
      try {
        const emailFromCode = await verifyPasswordResetCode(auth, oobCode);
        setEmail(emailFromCode || '');
        setStatus('idle');
      } catch (err) {
        setStatus('error');
        setMessage('This reset link is invalid or has expired.');
      }
    };
    verify();
  }, [oobCode]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    if (!newPassword || newPassword.length < 6) {
      setStatus('error');
      setMessage('Password must be at least 6 characters.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setStatus('error');
      setMessage('Passwords do not match.');
      return;
    }
    try {
      await confirmPasswordReset(auth, oobCode, newPassword);
      setStatus('success');
      setMessage('Your password has been reset. You can now log in.');
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      setStatus('error');
      setMessage('Unable to reset password. Please try again.');
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh]">
      <h2 className="heading-primary-1 text-4xl font-extrabold text-center mb-6">Reset Your Password</h2>
      <p className="text-lg text mb-6 text-center">
        {email ? `Resetting password for ${email}` : 'Follow the link from your email to reset your password.'}
      </p>
      <form onSubmit={handleSubmit} className="w-full max-w-sm card p-8 rounded-lg shadow-md">
        <div className="mb-4">
          <label htmlFor="newPassword" className="block text-muted text-sm font-bold mb-2">New Password</label>
          <input
            type="password"
            id="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="input-field"
            placeholder="Enter new password"
            required
          />
        </div>
        <div className="mb-6">
          <label htmlFor="confirmPassword" className="block text-muted text-sm font-bold mb-2">Confirm Password</label>
          <input
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="input-field"
            placeholder="Confirm new password"
            required
          />
        </div>
        <button type="submit" className="btn btn-primary w-full">
          Reset Password
        </button>
        {message && (
          <p className={`text-sm mt-4 text-center ${status === 'success' ? 'text-success' : 'text-danger'}`}>{message}</p>
        )}
      </form>
    </div>
  );
};
